import { useFormikContext } from "formik";
import {
  SummaryTable,
  SummaryTableRow,
} from "@poseidon/ui/components/SummaryTable";
import { formatCurrency } from "@poseidon/utils/currency";
import Button from "@mui/material/Button";
import React from "react";
import { usePermissions } from "@poseidon/ui/components";
import { RateTypeChip } from "../components/RateTypeChip";

export const ReschedulePreview = ({ data, onApply }) => {
  const { canWrite } = usePermissions();
  const { values } = useFormikContext();
  return (
    <>
      <RateTypeChip fixedRate={data.fixedRate} size="medium" sx={{ mb: 2 }} />
      <SummaryTable>
        <SummaryTableRow label="Start Date">
          {data.startDate.toLocaleDateString("en-GB")}
        </SummaryTableRow>
        <SummaryTableRow label="Annual Rate">{data.rate}%</SummaryTableRow>
        <SummaryTableRow label="Principal">
          {formatCurrency(data.principal)}
        </SummaryTableRow>
        <SummaryTableRow label="Term">
          {Math.ceil(data.term)} months
        </SummaryTableRow>
        {data.balloon > 0 && (
          <SummaryTableRow label="Balloon">
            {formatCurrency(data.balloon, true)}
          </SummaryTableRow>
        )}
        <SummaryTableRow label="Payments">
          <ul>
            {data.payments.map((payment, index) => (
              <li key={index}>
                {payment.count} &times;{" "}
                {formatCurrency(Math.abs(payment.amount))}
              </li>
            ))}
          </ul>
        </SummaryTableRow>
      </SummaryTable>
      <Button
        variant="contained"
        onClick={() => onApply(values)}
        margin="normal"
        color="error"
        disabled={!canWrite}
      >
        Apply Reschedule
      </Button>
    </>
  );
};
